var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.622 28.878c.378.337.87.517 1.377.502a1.938 1.938 0 0 0 2.043-1.81l.216-1.798c2.154-.628 3.46-2.282 3.785-4.8l1.961-15.128c.42-.068.847-.099 1.273-.092a6.89 6.89 0 0 1 1.867.242v22.937H31V10.49c0-2.502-1.122-4.269-3.167-5.004V4.297c0-1.374-.845-2.297-2.075-2.297-1.229 0-2.018.779-2.218 2.182l-.153 1.101c-2.231.633-3.554 2.433-3.934 5.356L17.64 25.217a8.64 8.64 0 0 1-3.28 0l-1.813-14.581c-.388-2.921-1.696-4.721-3.934-5.347L8.46 4.188c-.2-1.41-.978-2.181-2.218-2.181s-2.075.922-2.075 2.297v1.189C2.122 6.228 1 7.995 1 10.497v18.44H4.85V5.997a6.89 6.89 0 0 1 1.867-.243c.426-.006.852.024 1.272.092l1.96 15.127c.332 2.563 1.607 4.177 3.787 4.799l.228 1.795c.044.505.28.974.657 1.311z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMina);
export default __webpack_public_path__ + "static/media/MINA.3f44739bbaf88b8d68d4894c3552dde2.svg";
export { ForwardRef as ReactComponent };